import { DefineAppCenterPermissionAbility } from "@/config/appCenter";
import { DefineDepartmentPermissionAbility } from "@/config/department";
import { DefineEmployeePermissionAbility } from "@/config/employee";
import { DefineRevenueDeductPermissionAbility } from "@/config/revenueDeduct";
import { DefineSalaryPermissionAbility } from "@/config/salary";
import { DefineSettingPermissionAbility } from "@/config/setting";
import { AbilityAction, AbilitySubject } from "@/enums/enums";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { ApplicationPermissionModel } from "@/model/user/ApplicationPermissionModel";
import { Ability, AbilityBuilder } from "@casl/ability";
import Pako from "pako";

function DecompressApplicationPermission(merchant: SelectedMerchantModel): ApplicationPermissionModel {
  let applicationPermission: ApplicationPermissionModel = new ApplicationPermissionModel(
    merchant.roleApplication?.isSuperUser ?? false
  );
  const compressedApplicationPermission: string = merchant.applicationPermission;

  if (compressedApplicationPermission) {
    const binaryData = Uint8Array.from(atob(compressedApplicationPermission), (byte) => byte.charCodeAt(0));
    const decompressedData = Pako.inflateRaw(binaryData, { to: "string" });
    applicationPermission = JSON.parse(decompressedData);
  }

  return applicationPermission;
}

export function DefineAbilityFor(merchant: SelectedMerchantModel) {
  type PayrollAbility = Ability<[AbilityAction, AbilitySubject]>;
  const { can, rules } = new AbilityBuilder<PayrollAbility>();

  const applicationPermission: ApplicationPermissionModel = DecompressApplicationPermission(merchant);
  const { salary, employee, department, revenueDeduct, setting }: ApplicationPermissionModel = applicationPermission;

  DefineAppCenterPermissionAbility(merchant.roleApplication, merchant.merchantPackageRight.application, can);

  DefineSalaryPermissionAbility(salary, can);
  DefineEmployeePermissionAbility(employee, can);
  DefineDepartmentPermissionAbility(department, can);
  DefineRevenueDeductPermissionAbility(revenueDeduct, can);
  DefineSettingPermissionAbility(setting, can);

  return rules;
}
